import { useCallback, useRef } from 'react';

interface IData {
  [key: string]: any;
}

const createEvent = (
  eventName: string,
  renderingCount: number,
  data: IData,
): CustomEvent => {
  const event = new CustomEvent(eventName, {
    detail: {
      eventName,
      count: renderingCount,
      data,
    },
  });

  return event;
};

type UseEvent = (
  eventName: string,
  data: IData,
) => {
  renderingCount: number;
  triggerEvent: (data?: any) => void;
};

export const useEvent: UseEvent = (eventName, data) => {
  const renderingCountRef = useRef<number>(0);

  const triggerEvent = useCallback(
    (triggerData = null) => {
      renderingCountRef.current += 1;

      const event = createEvent(
        eventName,
        renderingCountRef.current,
        triggerData || data,
      );
      window.dispatchEvent(event);
    },
    [eventName, data],
  );

  return { renderingCount: renderingCountRef.current, triggerEvent };
};
